'use strict'

import Advices from '@/pages/Advice/KPIList.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/advices',
    name: 'Advices',
    component: Advices,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/advice.js